<template>
<div>
  <md-dialog :md-active.sync="_showTagDialog" v-if="isLoaded">
    <md-dialog-title>選擇標籤</md-dialog-title>
    <md-dialog-content>
      <md-tabs>
        <md-tab md-label="選擇標籤">
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>標籤類別</label>
                <md-select v-model="selectedGroup">
                  <md-option v-for="group in groups" :groups="groups" :key="group.id" :value="group.id">
                    {{group.name}}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-table>
                <md-table-row>
                  <md-table-head>名稱</md-table-head>
                </md-table-row>
                <md-table-row v-for="tag in tags" :key="tag.id" :tags="tags">
                  <md-table-cell>
                    <a @click="addTag(tag)">
                      {{tag.name}}
                    </a>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </div>
        </md-tab>
      </md-tabs>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary" @click="$emit('close')">關閉</md-button>
    </md-dialog-actions>
  </md-dialog>
</div>
</template>

<script>
import axios from 'axios'
import urls from '@/urls'

export default {
  props: ['showTagDialog'],
  data () {
    return {
      tags: [],
      groups: [],
      selectedGroup: null,
      selectedGroupColor: null
    }
  },
  components: {
  },
  watch: {
    selectedGroup: function (val) {
      this.selectedGroupColor = this.groups.find(i => i.id === val).color
      this.getTags(val)
    }
  },
  computed: {
    _showTagDialog: {
      get: function () {
        return this.showTagDialog
      },
      set: function (val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  created () {
    this.getGroups()
    this.isLoaded = true
  },
  methods: {
    async getGroups () {
      let result = await axios.get(urls({route: 'tag-group'}), {params: {page: 0}})
      this.groups = result.data.data
    },
    async getTags (groupID) {
      let result = await axios.get(urls({route: `tag-group/${groupID}/tag`}), {params: {page: 0}})
      this.tags = result.data.data
    },
    addTag (tag) {
      this.$emit('addTag', {
        ...tag,
        tag_group: this.groups.find(i => i.id === this.selectedGroup),
        color: this.selectedGroupColor
      })
      this.$emit('close')
    }
  }
}
</script>

<style>
.md-menu-content {
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/Patient/SelectTag.vue